<template>
  <el-container>
    <el-header>
      <h2>咨询问题展示</h2>
    </el-header>
    <el-main>
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item, index) in questions" :key="index">
          <el-card>
            <h3>问题 {{ index + 1 }}：</h3>
            <p>{{ item.question }}</p>
            <el-divider></el-divider>
            <h4>答复：</h4>
            <p>{{ item.answer }}</p>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { ref } from "vue";

export default {
  name: "QuestionsDisplay",
  setup() {
    // 示例数据
    const questions = ref([
      { question: "如何安装 Vue 3？", answer: "请使用 npm install vue@next。" },
      { question: "Element Plus 是什么？", answer: "这是一个基于 Vue 3 的 UI 框架。" },
      { question: "如何配置路由？", answer: "可以使用 Vue Router 实现路由功能。" },
    ]);

    return { questions };
  },
};
</script>

<style>
h2 {
  text-align: center;
  margin: 20px 0;
}
h3 {
  color: #409eff;
}
h4 {
  color: #67c23a;
}
</style>
